<template lang='pug'>
DataProvider(
  ref='dataProvider',
  :endpoint='requestPath',
  baseUrl='/requestTemplates',
  :filter='filter')
  div(slot-scope='{ data: response, error, loading }')
    .md-layout
      .md-layout-item.ml-auto
        md-button.md-warning(@click='openDialog()' style='float: right;')
          v-icon#createButton(style='margin-right: 10px; height: 26px;') mdi-plus
          span(style='color: black;')
            | {{ $t("integrations.newTemplate") }}
    DataTable(
      :data='(response && response.data) || []'
      ref='dataTable'
      :title="$t('integrations.apiRequestTemplates')",
      :customTotal='(response && response.total) || 0',
      :loading='loading'
      @search-query='handleSearch'
      @pagination='handlePagination'
      @click-row='openDialog'
      @delete-selected='deleteSelected'
      @selected-items='checkSelected'
      :allowDeleteSelected='allowDeleteSelected'
      :endpoint='requestPath'
      :filter='filter'
      :labels='labels'
      :formatLabelFunction='formatLabels',
      fileName="API_request_templates"
      :createHeader='createHeaderPDF')
      template(slot='cells' slot-scope='{ item }')
        md-table-cell(
          :md-label='labels[0]'
          :md-sort-by="$t('integrations.name')"
          style='color: #4caf50;')
          | {{ formatLabels(item, 0) }}
        md-table-cell(:md-label='labels[1]')
          | {{ formatLabels(item, 1) }}
        md-table-cell(:md-label='labels[2]')
          | {{ formatLabels(item, 2) }}
        md-table-cell(:md-label='labels[3]')
          | {{ formatLabels(item, 3) }}
      template(v-if='!allowDeleteSelected' v-slot:deleteSelectedMessage)
        v-icon(style='float: left; margin-right: 5px') mdi-alert-circle-outline
        | {{ $t("integrations.cantDeleteGlobal") }}
    .error(v-if='error') Houve um erro: {{ error.message }}
    md-dialog#requestDialog(
      :md-active.sync='dialog'
      md-close-on-esc
      md-click-outside-to-close)
      v-toolbar.px-4(
        style='background: linear-gradient(60deg, #66bb6a, #43a047); color: white;')
        span(
          style=' font-size: 1.125rem; line-height: 1.4em; font-weight: 300; font-size: 18px;')
          | {{ dialogTitle }}
        v-spacer
        md-button.md-simple.md-just-icon(@click='closeDialog')
          md-icon close
      md-dialog-content(style='width: 100%; padding: 0 24px;')
        md-card-content
          RequestTemplate(
            v-model='requestTemplate._source',
            :readOnly='templateIsGlobal'
            ref='requestTemplateRef')
      .md-layout
        .md-layout-item.ml-auto
          div(v-show='templateIsGlobal' style='float: right; margin: 15px;')
            v-icon.text-warning(style='float: left; margin-right: 5px') mdi-alert-circle-outline
            p(style='float: right;' v-show='templateIsGlobal')
              | {{ $t("integrations.editGlobal") }}
          md-button.md-success(
            v-show='!templateIsGlobal'
            @click='save'
            style='float: right; margin: 15px;')
            | {{ $t("commonWords.save") }}
</template>

<script>
import Swal from 'sweetalert2'
import DataTable from '@/components/DataTable'
import DataProvider from '@/components/DataProvider'
import RequestTemplate from '@/components/RequestTemplate'

// const labelsTable = [
//   this.$t('commonWords.global'), this.$t('commonWords.description'), this.$t('commonWords.updatedAt')
// ]

export default {
  components: {
    DataTable,
    DataProvider,
    RequestTemplate
  },
  data () {
    return {
      labels: [],
      requestPath: 'request-templates',
      requestTemplate: {},
      allowDeleteSelected: true,
      dialog: false,
      dialogType: '',
      filter: {
        page: 0,
        perPage: 5
      }
    }
  },
  methods: {
    description (source) {
      return `${source.method} ${source.host}${source.path}`
    },
    dateFormatter (dateStr) {
      return new Date(dateStr).toLocaleString('pt-br')
    },
    checkSelected (selectedItems = []) {
      const anyIsGlobal = selectedItems.some((item) => item._source.isGlobal)
      // console.log(`anyIsGlobal`, anyIsGlobal, selectedItems)
      if (anyIsGlobal) {
        this.allowDeleteSelected = false
      } else {
        this.allowDeleteSelected = true
      }
    },
    async deleteSelected (selected) {
      try {
        const delay = new Promise((resolve) => setTimeout(resolve, 1000))
        Swal.fire({
          title: this.$t('commonPhrases.loading') + '...',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          }
        })
        const requests = selected.map(async (item) => {
          try {
            await this.$axios.delete(`${this.requestPath}/${item._id}`)
            return Promise.resolve(item._source.name)
          } catch (error) {
            return Promise.reject(item._source.name)
          }
        })
        /** @type {Array} */
        const responses = await Promise.allSettled(requests)
        // console.log(`result`, responses)
        this.$refs.dataProvider.load()
        this.closeDialog()
        await delay

        const failed = responses
          .filter((response) => response.status === 'rejected')
          .map((response) => `'${response.reason}'`)
          .join(', ')
        if (failed) {
          Swal.fire(
            `${this.$t('commonWords.error')}!`,
            `${this.$t('integrations.templatesNotRemoved')}: ${failed}`,
            'error'
          )
        } else {
          const removed = responses
            .map((response) => `'${response.value}'`)
            .join(', ')
          await Swal.fire(
            `${this.$t('commonWords.success')}!`,
            `${this.$t('integrations.templatesRemoved')}: ${removed}`,
            'success'
          )
        }
      } catch (e) {
        // console.error(e)
        // console.error(e.response)
        Swal.fire(
          `${this.$t('commonWords.error')}!`,
          e.response?.data?.message || e.response?.data?.error || e.message,
          'error'
        )
      } finally {
        this.$refs.dataTable.clearSelection()
      }
    },
    handlePagination (pagination, oldPagination) {
      const newFilter = {}
      const { currentPage, perPage } = pagination
      if (currentPage && this.filter.page !== currentPage - 1) {
        newFilter.page = currentPage - 1
      }
      if (perPage && this.filter.perPage !== perPage) {
        newFilter.perPage = perPage
      }
      Object.assign(this.filter, newFilter)
    },
    handleSearch (searchText) {
      if (searchText) {
        this.$set(this.filter, 'q', searchText)
      } else {
        this.$delete(this.filter, 'q')
      }
    },
    openDialog (rowProps) {
      this.dialogType = rowProps ? 'edit' : 'create'
      if (rowProps?.item) {
        this.requestTemplate = rowProps.item
      } else {
        this.requestTemplate = { _source: {} }
        this.$nextTick(() => {
          this.$refs.requestTemplateRef.reset()
        })
      }
      this.dialog = true
    },
    closeDialog () {
      this.dialog = false
    },
    async save () {
      const passed = await this.$refs.requestTemplateRef.validate()
      if (passed) {
        const delay = new Promise((resolve) => setTimeout(resolve, 1000))
        Swal.fire({
          title: this.$t('commonPhrases.loading') + '...',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          }
        })
        // console.log({ ...this.requestTemplate })
        const { requestType, requestPath } = ((type, template) => {
          if (type === 'create') {
            return {
              requestType: 'post',
              requestPath: this.requestPath
            }
          } else if (type === 'edit') {
            return {
              requestType: 'put',
              requestPath: `${this.requestPath}/${template._id}`
            }
          } else {
            alert('Development error: unknown dialogType value')
            throw new Error('Unknown dialogType value')
          }
        })(this.dialogType, this.requestTemplate)
        // console.log(`request post`, this.requestTemplate._source)
        try {
          await this.$axios[requestType](
            requestPath,
            this.requestTemplate._source
          )
          // console.log(`result`, result)
          await delay
          Swal.fire(
            `${this.$t('commonWords.success')}!`,
            `${this.$t('integrations.templateSaved')}!`,
            'success'
          )
          this.$refs.dataProvider.load()
          this.closeDialog()
        } catch (e) {
          // console.error(e)
          // console.error(e.response)
          await delay
          Swal.fire(
            `${this.$t('commonWords.error')}!`,
            e.response?.data?.message || e.response?.data?.error || e.message,
            'error'
          )
        }
      }
    },
    showSuccessAlert () {},
    formatLabels (item, i) {
      switch (i) {
        case 0:
          return item._source.name
        case 1:
          return item._source.isGlobal ? this.$t('commonWords.yes') : this.$t('commonWords.no')
        case 2:
          return this.description(item._source)
        case 3:
          return this.dateFormatter(item._source.updatedAt)
        default:
          break
      }
    },
    createHeaderPDF (doc, total) {
      doc.setFontSize(14)
      doc.setFont(undefined, undefined, '700')
      doc.text(15, 10, this.$t('integrations.apiRequestTemplates'))

      doc.setFontSize(10)

      doc.setFont('times', undefined, '700')
      doc.text(15, 22, 'Total: ')
      doc.setFont(undefined, undefined, '300')
      doc.text(25, 22, `${total}`)

      const tableOffsetY = 30
      return tableOffsetY
    }
  },
  computed: {
    dialogTitle () {
      const dialogType =
        this.dialogType === 'create'
          ? this.$t('commonWords.create')
          : this.$t('commonWords.edit')
      return `${dialogType} ${this.$t('integrations.requestTemplate')}`
    },
    templateIsGlobal () {
      return this.requestTemplate?._source?.isGlobal
    }
  },
  beforeMount () {
    this.labels = [this.$t('commonWords.name'), this.$t('commonWords.global'), this.$t('commonWords.description'), this.$t('commonWords.updatedAt')]
  }
}
</script>

<style lang="css">
.md-button:not(.md-just-icon) .md-button-content i#createButton {
  color: black !important;
  font-size: 28px !important;
}
.md-checkbox.md-checked .md-checkbox-container:after {
  border-color: #33b231 !important;
  top: 1px !important;
  left: 6px !important;
}
.md-table-cell-container {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
#requestDialog > .md-dialog-container {
  width: 100%;
}
</style>
